import {useQuery} from "@tanstack/react-query";
import {readHandlerDataApi} from "../../../../api/support/RMA";

export const useReadHandlerData = () => {
    const {data} = useQuery({
        queryKey: ["readHandlerData"],
        queryFn: async () => await readHandlerDataApi(),
        select: (res) => res?.result.handlerVOList ?? null,
    });

    return {data};
};
